import "./TermsAndConditions.module.css";
import Header from "@/reusable_sections/Header";
import WhySupportMatters from "./sections/WhySupportMatters";
import ServicesGrid from "./sections/ServicesGrid";
import TheCuratedExperience from "./sections/TheCuratedExperience";
import WithdrawalFaqs from "./sections/WithdrawalFaqs";
import Footer from "@/reusable_sections/Footer";
export default function TermsAndConditionsPage() {
  return <div>
      <Header />
      <WhySupportMatters />
      <ServicesGrid />
      <TheCuratedExperience />
      <WithdrawalFaqs />
      <Footer />
    </div>;
}